import { connect } from 'react-redux';
import { loginAction } from '@smorder/logic';
import { navigate } from '../reducers/navigator.reducers';
import { errorNotification } from '../reducers/notification.reducers';
import Login from './login';

const mapStateToProps = state => ({
  loggedIn: state.authentication.loggedIn,
  userName: state.authentication.userName,
  loading: state.authentication.loading,
  errorMessage: state.authentication.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  login: (credentials) => {
    dispatch(loginAction.INIT(credentials));
  },
  navigate: (route) => {
    dispatch(navigate({ route }));
  },
  errorNotification: (message) => {
    dispatch(errorNotification(message));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
